import React, { lazy, Suspense } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import GenericNotFound from '../Hoc/GenericNotFound';
import Loader from '../Hoc/Loader';
import SignUp from '../pages/SignUp/SignUp';
import Login from '../pages/Login/Login';
import OnBoarding from '../pages/OnBoarding/OnBoarding';
import ForgetPassword from '../pages/ForgetPassword/ForgetPassword';
import DashboardMain from '../pages/DashboardPages/Dashboard/DashboardMain';
import LiveChat from '../pages/DashboardPages/LiveChat/LiveChat';
import ChatV2 from '../pages/DashboardPages/ChatV2/ChatV2';
import TeamManagment from '../pages/DashboardPages/TeamManagment/TeamManagment';
import RequireAuth from '../store/Authenticate/RequireAuth';
import RequireAdmin from '../store/Authenticate/RequireAdmin';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import Subscription from '../pages/Subscription/Subscription';
import AgentPassword from '../pages/AgentPassword/AgentPassword';
import DashboardComponents from '../components/mainDashboardContainer';
import TicketManagment from '../pages/DashboardPages/TicketManagment/TicketManagment';
import TicketV2 from '../pages/DashboardPages/TicketV2/TicketV2';
import ProfileManagment from '../pages/DashboardPages/ProfileManagment/ProfileManagment';
import Settings from '../pages/DashboardPages/Settings/Settings';
import EditGroupMain from '../components/dashboardcomponents/TeamComponents/EditGroup/EditGroupMain';
import EditProfileMain from '../components/dashboardcomponents/TeamComponents/TeamEditProfile/EditProfileMain';
import CreateUserFromInviteLink from '../components/dashboardcomponents/TeamComponents/CreateUserFromInviteLink';
import AcceptGroupInvite from '../components/dashboardcomponents/TeamComponents/AcceptGroupInvite';
import CreatePassword from '../pages/ForgetPassword/CreatePassword';
import TickeetChatSection from '../components/dashboardcomponents/TicketSectionComponents/TicketChatSection/TickeetChatSection';
import TrafficManagement from '../pages/DashboardPages/UserTraffic/TrafficManagement';
import WidgetSettings from '../components/dashboardcomponents/Settings/WidgetSettings';
import Notification from '../components/dashboardcomponents/Settings/Notification';
import DataExport from '../components/dashboardcomponents/Settings/DataExport';
import CompanySettings from '../components/dashboardcomponents/Settings/CompanySettings';
import MainAnalyticsOverview from '../pages/Analytics/Overview/MainOverview';
import MainAnalyticsTickets from '../pages/Analytics/Tickets/MainTickets';
import MainAnalyticsAgents from '../pages/Analytics/Agents/MainAgents';
import MainChatsAnalytics from '../pages/Analytics/Chats/MainChatsAnalytics';
import Overview from '../pages/DashboardPages/KnowledgeBase/Overview/Overview';
import Articles from '../pages/DashboardPages/KnowledgeBase/Articles/Articles';
import Categories from '../pages/DashboardPages/KnowledgeBase/Categories/Categories';
import ReviewQueue from '../pages/DashboardPages/KnowledgeBase/ReviewQueue/ReviewQueue';
import FeedbackQueue from '../pages/DashboardPages/KnowledgeBase/FeedbackQueue/FeedbackQueue';
import Customization from '../pages/DashboardPages/KnowledgeBase/Customization/Customization';
import NewArticle from '../pages/DashboardPages/KnowledgeBase/NewArticle/NewArticle';
import ArticleDetail from '../pages/DashboardPages/KnowledgeBase/ArticleDetail/ArticleDetail';
import PublicArticleView from '../pages/DashboardPages/KnowledgeBase/PublicArticleView/PublicArticleView';
import { useSelector } from 'react-redux';
import MainKnowledgeBase from '../pages/Analytics/KnowledgeBase/MainKnowledgeBase';
import MainAnalyticsDataExport from '../pages/Analytics/DataExport/MainAnalyticsDataExport';
import KnowledgeBaseHome from '../pages/DashboardPages/KnowledgeBase/KnowledgeBaseLandingPage/KnowledgeBaseHome';

import KnowledgeBaseCategoryPage from '../pages/DashboardPages/KnowledgeBase/KnowledgeBaseCategoryDetailsPage/KnowledgeBaseCategoryPage';
import LinkExpired from '../pages/LinkExpired/LinkExpired';
import InvalidLink from '../pages/InvalidLink/InvalidLink';
import MainKnowledgeBaseLayout from '../components/dashboardcomponents/KnowledgeBase/MainknowledgeBaseLayout/MainKnowledgeBaseLayout';
import KnowledgeBaseSearch from '../pages/DashboardPages/KnowledgeBase/KnowldegeBaseSearchPage/KnowldgeBaseSearch';
import Search from '../pages/DashboardPages/Search/Search';
import Customers from '../pages/DashboardPages/People/Customers/Customers';
import CustomerDetailPage from '../pages/DashboardPages/People/Customers/CustomerDetail/CustomerDetailPage';
import CustomerEditPage from '../pages/DashboardPages/People/Customers/CustomerEdit/CustomerEditPage';
import Teams from '../pages/DashboardPages/People/Teams/Teams';
import TeamDetailPage from '../pages/DashboardPages/People/Teams/TeamDetail/TeamDetailPage';
import TeamEditPage from '../pages/DashboardPages/People/Teams/TeamEdit/TeamEditPage';
import Agents from '../pages/DashboardPages/People/Agents/Agents';
import AgentDetailPage from '../pages/DashboardPages/People/Agents/AgentDetail/AgentDetailPage';
import AgentEditPage from '../pages/DashboardPages/People/Agents/AgentEdit/AgentEditPage';
import Groups from '../pages/DashboardPages/People/Groups/Groups';
import GroupDetailPage from '../pages/DashboardPages/People/Groups/GroupDetail/GroupDetailPage';
import SettingsV2Layout from '../components/dashboardcomponents/SettingsV2/Layout/SettingsV2Layout';
import SettingsV2AdminLayout from '../components/dashboardcomponents/SettingsV2/Admin/SettingsV2AdminLayout';
import WorkspaceSettingsPage from '../components/dashboardcomponents/SettingsV2/Admin/tabs/WorkspaceSettingsPage';
import PlanBillingPage from '../components/dashboardcomponents/SettingsV2/Admin/tabs/PlanBillingPage';
import CustomDomainPage from '../components/dashboardcomponents/SettingsV2/Admin/tabs/CustomDomainPage';
import BusinessEmailPage from '../components/dashboardcomponents/SettingsV2/Admin/tabs/BusinessEmailPage';
import ChatWidgetPage from '../components/dashboardcomponents/SettingsV2/Admin/tabs/ChatWidgetPage';
import TicketRoutingPage from '../components/dashboardcomponents/SettingsV2/Admin/tabs/TicketRoutingPage';
import AccountSecurity from '../components/dashboardcomponents/SettingsV2/AccountSecurity/AccountSecurityPage';
import ActiveSessions from '../components/dashboardcomponents/SettingsV2/ActiveSessions/ActiveSessionsPage';
import TagManagement from '../components/dashboardcomponents/SettingsV2/Tags/TagManagementPage';
import CannedResponses from '../components/dashboardcomponents/SettingsV2/Canned/CannedResponsesPage';
import LinkEmail from '../components/dashboardcomponents/SettingsV2/LinkEmail/LinkEmailPage';
import NotificationPreferences from '../components/dashboardcomponents/SettingsV2/Notifications/NotificationPreferencesPage';

import { getTenantSlug } from '../utils/index';
import PeopleTeamModuleGuard from '../components/routing/PeopleTeamModuleGuard';
import LegacySettingsGuard from '../components/routing/LegacySettingsGuard';
import SettingsV2Redirect from '../components/routing/SettingsV2Redirect';
import { isLegacySettingsEnabled, SETTINGS_HOME_PATH } from '../config/featureFlags';
import LegacyTicketsGuard from '../components/routing/LegacyTicketsGuard';
import { NotificationOverlayProvider } from '../context/NotificationOverlayContext';
import { readNotificationsBackground } from '../utils/notificationsBackground';
import GuestOnlyRoute from '../components/routing/GuestOnlyRoute';
import LegacyLiveChatGuard from '../components/routing/LegacyLiveChatGuard';
import { LIVE_CHAT_V2_PATH } from '../config/featureFlags';
import PlatformAdminLayout from '../components/platformAdmin/PlatformAdminLayout';
import PlatformOverview from '../pages/PlatformAdmin/PlatformOverview';
import PlatformBusinesses from '../pages/PlatformAdmin/PlatformBusinesses';
import PlatformBusinessDetail from '../pages/PlatformAdmin/PlatformBusinessDetail';
import PlatformLogin from '../pages/PlatformAdmin/PlatformLogin';
import RequirePlatformAuth from '../components/platformAdmin/RequirePlatformAuth';

const AboutUs = lazy(() => import('../pages/AboutUs/AboutUsPageLoader'));

function TicketV2Redirect() {
  const location = useLocation();
  return <Navigate to={`/tickets${location.search}${location.hash}`} replace />;
}

function isNotificationsPath(pathname = '') {
  return pathname === '/notifications';
}

export default function RoutesMain() {
  const userData = useSelector((state) => state.loginToken);
  const KbRole = userData?.response?.user?.kbRole?.role;
  const tenantSlug = getTenantSlug();
  const location = useLocation();
  // Real browser location — not the Routes matching location
  const notificationsOpen = isNotificationsPath(location.pathname);
  const backgroundLocation = notificationsOpen
    ? location.state?.backgroundLocation || readNotificationsBackground()
    : null;

  return (
    <NotificationOverlayProvider open={notificationsOpen}>
      <Suspense fallback={<Loader />}>
        <Routes location={backgroundLocation || location}>
        {tenantSlug ? (
          <Route path="/" element={<MainKnowledgeBaseLayout />}>
            <Route index element={<KnowledgeBaseHome />} />
            <Route path="category/:slug" element={<KnowledgeBaseCategoryPage />} />
            <Route path=":articleId" element={<PublicArticleView />} />
            <Route path="search" element={<KnowledgeBaseSearch />} />
          </Route>
        ) : (
          <Route
            exact
            path="/"
            element={(
              <GuestOnlyRoute>
                <SignUp />
              </GuestOnlyRoute>
            )}
          />
        )}
        <Route
          exact
          path="/login"
          element={(
            <GuestOnlyRoute>
              <Login />
            </GuestOnlyRoute>
          )}
        />
        <Route exact path="/reset-password" element={<CreatePassword />} />



        <Route exact path="/create-userinvite" element={<CreateUserFromInviteLink />} />
        <Route exact path="/agent-password" element={<AgentPassword />} />
        <Route exact path="/link-expired" element={<LinkExpired />} />
        <Route exact path="/invalid-link" element={<InvalidLink />} />
        <Route exact path="/privacy" element={<PrivacyPolicy />} />
        <Route exact path="/subscription" element={<Subscription />} />
        <Route path="kb/view" element={<MainKnowledgeBaseLayout />}>
          <Route index element={<KnowledgeBaseHome />} />
          <Route path="category/:slug" element={<KnowledgeBaseCategoryPage />} />
          <Route path=":articleId" element={
            <PublicArticleView />
          } />
          <Route path="search" element={<KnowledgeBaseSearch />} />
        </Route>

        <Route
          exact
          path="/on-boarding"
          element={(
            <RequireAuth>
              <OnBoarding />
            </RequireAuth>
          )}
        />
        <Route path="" element={<DashboardComponents />}>
          <Route
            path="teamsection"
            element={(
              <RequireAuth>
                <PeopleTeamModuleGuard module="legacy-team">
                  <TeamManagment />
                </PeopleTeamModuleGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="groupupdate/:groupId"
            element={(
              <RequireAuth>
                <PeopleTeamModuleGuard module="legacy-team">
                  <EditGroupMain />
                </PeopleTeamModuleGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="userupdate/:userId"
            element={(
              <RequireAuth>
                <PeopleTeamModuleGuard module="legacy-team">
                  <EditProfileMain />
                </PeopleTeamModuleGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="user-traffic"
            element={(
              <RequireAuth>
                <TrafficManagement />
              </RequireAuth>
            )}
          />
          <Route
            path="Live"
            element={(
              <RequireAuth>
                <LegacyLiveChatGuard>
                  <LiveChat />
                </LegacyLiveChatGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="chat"
            element={(
              <RequireAuth>
                <ChatV2 />
              </RequireAuth>
            )}
          />
          <Route path="live" element={<Navigate to={LIVE_CHAT_V2_PATH} replace />} />
          <Route path="chatv2" element={<Navigate to={LIVE_CHAT_V2_PATH} replace />} />
          <Route
            path="ticketsection"
            element={(
              <RequireAuth>
                <LegacyTicketsGuard>
                  <TicketManagment />
                </LegacyTicketsGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="tickets"
            element={(
              <RequireAuth>
                <TicketV2 />
              </RequireAuth>
            )}
          />
          <Route path="ticketv2" element={<TicketV2Redirect />} />
          {/* <Route
            path="ticketsection/:ticketId"
            element={(
              <RequireAuth>
                <TickeetChatSection />
              </RequireAuth>
            )}
          /> */}
          <Route
            path="settings/profile"
            element={(
              <RequireAuth>
                <LegacySettingsGuard>
                  <ProfileManagment />
                </LegacySettingsGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="settings"
            element={(
              <RequireAuth>
                {isLegacySettingsEnabled ? (
                  <Settings />
                ) : (
                  <Navigate to={SETTINGS_HOME_PATH} replace />
                )}
              </RequireAuth>
            )}
          />

          <Route
            path="analytics/overview"
            element={(
              <RequireAuth>
                <MainAnalyticsOverview />
              </RequireAuth>
            )}
          />
          <Route
            path="analytics/tickets"
            element={(
              <RequireAuth>
                <MainAnalyticsTickets />
              </RequireAuth>
            )}
          />
          <Route
            path="analytics/chats"
            element={(
              <RequireAuth>
                <MainChatsAnalytics />
              </RequireAuth>
            )}
          />
          <Route
            path="analytics/agents"
            element={(
              <RequireAuth>
                <MainAnalyticsAgents />
              </RequireAuth>
            )}
          />
          <Route
            path="analytics/knowledgeBase"
            element={(
              <RequireAuth>
                <MainKnowledgeBase />
              </RequireAuth>
            )}
          />
          <Route
            path="analytics/data-export"
            element={(
              <RequireAuth>
                <MainAnalyticsDataExport />
              </RequireAuth>
            )}
          />


          <Route path="kb/overview" element={
            <RequireAuth>
              <Overview />
            </RequireAuth>
          } />
          <Route path="kb/articles" element={
            <RequireAuth>
              <Articles />
            </RequireAuth>
          } />
          <Route path="kb/categories" element={
            <RequireAuth>
              <Categories />
            </RequireAuth>
          } />
          {KbRole === 'editor' && <Route path="kb/review-queue" element={
            <RequireAuth>
              <ReviewQueue />
            </RequireAuth>
          } />}
          <Route path="kb/article/new" element={
            <RequireAuth>
              <NewArticle />
            </RequireAuth>
          } />
          <Route path="kb/article/:articleId" element={
            <RequireAuth>
              <ArticleDetail />
            </RequireAuth>
          } />
          {((KbRole === 'editor' || KbRole === 'contributor') && <Route path="kb/feedback-queue" element={
            <RequireAuth>
              <FeedbackQueue />
            </RequireAuth>
          } />)}
          {(KbRole === 'editor') && <Route path="kb/customization" element={
            <RequireAuth>
              <Customization />
            </RequireAuth>
          } />}

          <Route path="search" element={
            <RequireAuth>
              <Search />
            </RequireAuth>
          } />

          <Route
            path="settings/personal"
            element={(
              <RequireAuth>
                <SettingsV2Layout />
              </RequireAuth>
            )}
          >
            <Route index element={<Navigate to="account-security" replace />} />
            <Route path="account-security" element={<AccountSecurity />} />
            <Route path="active-sessions" element={<ActiveSessions />} />
            <Route path="tag-management" element={<TagManagement />} />
            <Route path="canned-responses" element={<CannedResponses />} />
            <Route path="link-email" element={<LinkEmail />} />
            <Route path="notification-preferences" element={<NotificationPreferences />} />
          </Route>
          <Route
            path="settings/admin"
            element={(
              <RequireAuth>
                <RequireAdmin>
                  <SettingsV2AdminLayout />
                </RequireAdmin>
              </RequireAuth>
            )}
          >
            <Route index element={<Navigate to="workspace-settings" replace />} />
            <Route path="workspace-settings" element={<WorkspaceSettingsPage />} />
            <Route path="plan-billing" element={<PlanBillingPage />} />
            <Route path="custom-domain" element={<CustomDomainPage />} />
            <Route path="business-email" element={<BusinessEmailPage />} />
            <Route path="chat-widget" element={<ChatWidgetPage />} />
            <Route path="ticket-routing" element={<TicketRoutingPage />} />
          </Route>
          <Route
            path="settings-v2/*"
            element={<SettingsV2Redirect />}
          />

          <Route path="people/customers" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <Customers />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/customers/:customerId/edit" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <CustomerEditPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/customers/:customerId" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <CustomerDetailPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/teams" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <Teams />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/teams/:teamId/edit" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <TeamEditPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/teams/:teamId" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <TeamDetailPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/agents" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <Agents />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/agents/:agentId/edit" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <AgentEditPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/agents/:agentId" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <AgentDetailPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/groups" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <Groups />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />
          <Route path="people/groups/:groupId" element={
            <RequireAuth>
              <PeopleTeamModuleGuard module="people">
                <GroupDetailPage />
              </PeopleTeamModuleGuard>
            </RequireAuth>
          } />


          <Route
            path="settings/notifications"
            element={(
              <RequireAuth>
                <LegacySettingsGuard>
                  <Notification />
                </LegacySettingsGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="settings/data-export"
            element={(
              <RequireAuth>
                <LegacySettingsGuard>
                  <DataExport />
                </LegacySettingsGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="settings/company-settings"
            element={(
              <RequireAuth>
                <LegacySettingsGuard>
                  <CompanySettings />
                </LegacySettingsGuard>
              </RequireAuth>
            )}
          />
          <Route
            path="dashboard"
            element={(
              <RequireAuth>
                <DashboardMain />
              </RequireAuth>
            )}
          />
          {/* Overlay route: empty page; InterceptingOutlet keeps prior page mounted */}
          <Route
            path="notifications"
            element={(
              <RequireAuth>
                <DashboardMain />
              </RequireAuth>
            )}
          />
          <Route
            path="settings/chat-widget"
            element={(
              <RequireAuth>
                <LegacySettingsGuard>
                  <WidgetSettings />
                </LegacySettingsGuard>
              </RequireAuth>
            )}
          />

        </Route>


        <Route path="/platform-admin/login" element={<PlatformLogin />} />
        <Route
          path="/platform-admin"
          element={(
            <RequirePlatformAuth>
              <PlatformAdminLayout />
            </RequirePlatformAuth>
          )}
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<PlatformOverview />} />
          <Route path="businesses" element={<PlatformBusinesses />} />
          <Route path="businesses/:businessId" element={<PlatformBusinessDetail />} />
        </Route>
        {/* Legacy Support Console URLs */}
        <Route path="/support/login" element={<Navigate to="/platform-admin/login" replace />} />
        <Route path="/support/*" element={<Navigate to="/platform-admin/overview" replace />} />

        <Route exact path="/forget-password" element={<ForgetPassword />} />
        <Route exact path="/accept-group-invitation/:token/:id" element={<AcceptGroupInvite />} />
        <Route path="/about-us" exact element={<AboutUs />} />

        <Route path="*" element={<GenericNotFound />} />
      </Routes>
    </Suspense>
    </NotificationOverlayProvider>
  );
}
